import { actions } from "@shared/template/StoreTemplates/FilterStoreTemplate"
export default {
  clearFilters({ dispatch }) {
    dispatch("updateFilters", [])
  },
  ...actions
}
